import { createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice";
import { format, parseISO } from "date-fns";

const notificationAdapter = createEntityAdapter({
  selectId: (notification) => notification.notificationId,
  sortComparer: (a, b) => b.notificationId - a.notificationId,
});

const initialState = notificationAdapter.getInitialState();

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllNotifications: builder.query({
      query: (userId) => `/Notification`,
      transformResponse: (responseData) => {
        return notificationAdapter.setAll(initialState, responseData);
      },
      providesTags: (result, error, arg) => [
        { type: "Notification", id: "LIST" },
        ...result.ids.map((id) => ({ type: "Notification", id })),
      ],
    }),
    getNotificationsByUserId: builder.query({
      query: (userId) => `/Notification/${userId}`,
      transformResponse: (responseData) => {
        const loadednotifications = responseData.map((notification) => {
          if (notification?.createDate) {
            notification.notificationDate = format(
              parseISO(notification.createDate),
              "dd/MM/yyyy"
            );
            notification.notificationTime = format(
              parseISO(notification.createDate),
              "HH:mm"
            );
          }

          if (notification?.receiverStatus) {
            if (
              notification.receiverStatus == "Created" ||
              notification.receiverStatus == "Sent"
            ) {
              notification.isRead = false;
            } else {
              notification.isRead = true;
            }
          }

          return notification;
        });
        return notificationAdapter.setAll(initialState, loadednotifications);
      },
      providesTags: (result, error, arg) => [
        { type: "Notification", id: "LIST" },
        ...result?.ids?.map((id) => ({ type: "Notification", id })),
      ],
    }),
    updateNotification: builder.mutation({
      query: (initialnotification) => ({
        url: "/Notification",
        method: "PUT",
        body: {
          ...initialnotification,
        },
      }),
      invalidatesTags: [{ type: "Notification", id: "LIST" }],
    }),
    clearNotification: builder.mutation({
      query: (notificationIds) => ({
        url: "/Notification/clear",
        method: "PUT",
        body: {
          ...notificationIds,
        },
      }),
      invalidatesTags: [{ type: "Notification", id: "LIST" }],
    }),
    readNotification: builder.mutation({
      query: (notificationIds) => ({
        url: "/Notification/read",
        method: "PUT",
        body: {
          ...notificationIds,
        },
      }),
      invalidatesTags: [{ type: "Notification", id: "LIST" }],
    }),
  }),
});

export const {
  useGetAllNotificationsQuery,
  useGetNotificationsByUserIdQuery,
  useUpdateNotificationMutation,
  useClearNotificationMutation,
  useReadNotificationMutation,
} = extendedApiSlice;
